import React, { useEffect, useState } from 'react';

import { Drawer } from '@material-ui/core';

import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const blocRef = useBlocRef('drawerBloc');
  const [drawerDetails, setDrawerDetails] = useState(null);

  useEffect(() => {
    const sub = blocRef.current.drawerDetails$.subscribe(setDrawerDetails);
    return () => sub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    blocRef.current.toggleDrawer(open);
  };

  return drawerDetails ? (
    <Drawer anchor={drawerDetails.anchor} open={drawerDetails.open} onClose={toggleDrawer(false)}>
      <drawerDetails.component {...drawerDetails.props} />
    </Drawer>
  ) : null;
};
